export function isNanFinite(value: number) {
    if (isNaN(value) || !isFinite(value)) {
        return true;
    }

    return false;
}
